@if (isVisible) {
  <div class="dropdown-backdrop" (click)="onBackdropClick($event)">
    <ul
      class="dropdown-menu show"
      [style.left.px]="position.x"
      [style.top.px]="position.y"
      (click)="$event.stopPropagation()"
    >
      @for (item of items; track item.id) {
        <li>
          <button
            type="button"
            class="dropdown-item"
            (click)="onItemClick(item.id)"
          >
            {{ item.label | abpLocalization }}
          </button>
        </li>
      }
    </ul>
  </div>
}
